import { TooltipProps } from 'recharts';
import { ReactElement, useEffect, useRef } from 'react';
import ChartTooltip from '../../ChartTooltip/ChartTooltip';
import ChartTooltipContent from '../../ChartTooltipContent/ChartTooltipContent';
import { TooltipVariants } from '../../constants';

interface SingleValueTooltipProps {
  payload: Array<TooltipProps<any, any>>;
  onChangeTooltipWidth: Function;
  tooltip?: string;
  tooltipVariant?: TooltipVariants;
  isTooltipActive: boolean;
}

export const SingleValueTooltip = ({
  payload,
  onChangeTooltipWidth,
  tooltip,
  tooltipVariant,
  isTooltipActive,
}: SingleValueTooltipProps): ReactElement | null => {
  const customTooltipRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (customTooltipRef.current) {
      onChangeTooltipWidth(customTooltipRef.current.getBoundingClientRect()?.width);
    }
  }, [customTooltipRef.current]);

  if (tooltip) {
    return (
      <ChartTooltip active={isTooltipActive} innerRef={customTooltipRef}>
        <ChartTooltipContent chartName="sample" payload={payload} title={tooltip} tooltipVariant={tooltipVariant} />
      </ChartTooltip>
    );
  }
  return null;
};
